<template>
  <div class="container-fluid bg-secondary">
    <div class="intro-page">
      <div class="intro-header">
        <div class="intro-header__options">
          <div class="intro-header__options--sede">
            <span class="intro-header__options--sede-ciudad">{{
              $t('header.sede.ciudad')
            }}</span>
            <span class="intro-header__options--sede-direccion">{{
              $t('header.sede.direccion')
            }}</span>
          </div>
          <div class="intro-header__options--language">
            <LanguageChange padding="0px" />
          </div>
        </div>
        <img class="intro-header__logo" src="img/logo_white.svg" />
      </div>
      <Slider
        heightViewport="100%"
        heightCamera="65vh"
        heightDekstopCamera="65vh"
        :autoplay="true"
        :pagination="true"
        :circular="true"
        :bound="false"
        duration="1000"
      >
        <template #content>
          <div
            class="flicking-panel"
            width="100%"
            v-for="card in cardsSliderIntro"
            :key="card.title"
          >
            <CardIntro
              :widthMobile="'100%'"
              :heightMobile="'700px'"
              :width="'100%'"
              :height="'100%'"
              :image="getImage(card)"
              :title="card.title"
              :subtitle="card.subtitle"
              :titleColor="colorDe(card, 'titleColor')"
              :subtitleColor="colorDe(card, 'subtitleColor')"
              :justify="card.justify"
              :align="card.align"
            >
              <template #action>
                <button
                  v-if="card.button && card.url"
                  :style="estiloDelBoton(card)"
                  class="button-block button-outline__light--block"
                  @click="navigateToPage(card)"
                >
                  {{ card.button }}
                </button>
              </template>
            </CardIntro>
          </div>
        </template>
      </Slider>
    </div>
    <IntroTitle
      v-if="experienceTypesFilter.length"
      :title="$t('home.title')"
      padding="0px 20px"
      paddingDesktop="10px 50px"
      titleFontSize="1.6rem"
      titleMobileFontSize="1.3rem"
      descriptionAlign="initial"
      descriptionMobileAlign="initial"
      backgroundColor="#F6F6F6"
      backgroundMobileColor="#F6F6F6"
      id="menu-options"
    >
    </IntroTitle>
    <div class="cards-menu" v-if="experienceTypesFilter.length">
      <template v-if="experienceTypes.length < 1">
        <CardSelectionSkeleton
          imageWidth="20%"
          justifyContent="flex-start"
          v-for="n in 3"
          :key="n"
        />
      </template>
      <template v-else>
        <CardSelection
          :image="card.image"
          :info="false"
          :title="$t(card.title)"
          :subtitle="$t(card.subtitle)"
          imageWidth="30%"
          imageDesktopWidth="30%"
          imageHeight="100%"
          descriptionWidth="70%"
          titleSize="18px"
          subtitleSize="12px"
          labelGap="5px"
          @click="goToPage(card.url)"
          v-for="card in CardsSelection"
          :key="card.title"
        />
        <CardSelection
          :image="imageHost + card.reducedImageKey"
          :info="false"
          :title="card.title.defaultValue"
          :subtitle="card.description.defaultValue"
          imageWidth="30%"
          imageDesktopWidth="30%"
          imageHeight="100%"
          descriptionWidth="70%"
          titleSize="18px"
          subtitleSize="12px"
          labelGap="5px"
          @click="goTo(card)"
          v-for="card in experienceTypesFilter"
          :key="card.title"
        />
      </template>
    </div>
    <div class="map" v-if="plantas.length">
      <IntroTitle
        :title="$t('home.map.title')"
        padding="30px 20px"
        paddingDesktop="30px 0px"
        titleFontSize="1.6rem"
        titleMobileFontSize="1.3rem"
        descriptionAlign="initial"
        descriptionMobileAlign="center"
        backgroundColor="var(--theme-color)"
        backgroundMobileColor="#F6F6F6"
        :hideActionDesktop="true"
        id="maps"
        :subtitleMobile="false"
        subtitlePadding="10px"
        subtitleLineHeight="25px"
        :subtitle="$t('home.map.subtitle')"
      >
        <template #action>
          <IconChevronDown />
        </template>
      </IntroTitle>
      <div class="map__desktop">
        <div class="map__desktop--floors">
          <div
            v-for="(planta, i) in plantas"
            :key="planta.code"
            class="map__button"
            :class="[mapDekstop === i ? 'map__button--active' : '']"
            @click="changeMapDekstop(i)"
          >
            {{ planta.nombre }}
          </div>
        </div>
        <template v-for="(planta, i) in plantas" :key="'esc-' + planta.code">
          <div v-if="mapDekstop === i" class="map__desktop--cuerpo">
            <!--
              El plano, a la izquierda. El mismo dato que en movil: el limpio de
              la planta si lo hay, y si no el de la tarjeta que se esta mirando.
              El resalte va aparte y sigue al carrusel de al lado.
            -->
            <div
              v-if="planoDe(planta, selectedDesktopIndex)"
              class="map__desktop--plano top-to-bottom--effect"
            >
              <img :src="planoDe(planta, selectedDesktopIndex)" />
              <span
                v-if="planta.plan && resalteDe(planta, selectedDesktopIndex)"
                class="map__punto"
                :style="estiloDelPunto(resalteDe(planta, selectedDesktopIndex))"
              ></span>
            </div>
            <div class="map__dekstop--slider top-to-bottom--effect">
              <div v-if="planta.zonas.length < 3" class="map__pocas">
                <div
                  v-for="(zona, j) in planta.zonas"
                  :key="zona.code"
                  class="map__pocas--tarjeta"
                  @mouseenter="changeMapImageDesktop(j)"
                  @click="changeMapImageDesktop(j); irAZona(zona)"
                >
                  <Card
                    :class="{ 'selected-card': selectedDesktopIndex === j }"
                    :width="'300px'"
                    :height="'100%'"
                    :imageHeight="'145px'"
                    :imageDesktopHeight="'150px'"
                    :image="zona.image"
                    :title="zona.titulo"
                    :subtitle="zona.subtitulo"
                    :cursor="zona.url ? 'pointer' : 'default'"
                  />
                </div>
              </div>
              <Slider
                v-else
                :map="true"
                @changeMapImage="changeMapImageDesktop"
                :autoplay="true"
              :autoplayTime="3000"
              :pagination="true"
              cardHeight="100%"
              :bound="false"
              :circular="true"
              :align="alignSliderDesktop"
              heightViewport="100%"
              heightCamera="100%"
              :defaultIndex="1"
              duration="1000"
            >
              <template #content>
                <div
                  class="card-slide"
                  width="100%"
                  v-for="zona in planta.zonas"
                  :key="zona.code"
                  @click="irAZona(zona)"
                >
                  <Card
                    :width="'300px'"
                    :height="'100%'"
                    :imageHeight="'145px'"
                    :imageDesktopHeight="'150px'"
                    :image="zona.image"
                    :title="zona.titulo"
                    :subtitle="zona.subtitulo"
                    :cursor="zona.url ? 'pointer' : 'default'"
                  />
                </div>
              </template>
              </Slider>
            </div>
          </div>
        </template>
      </div>
      <div class="map__mobile">
        <Tabs :titulos="pestanas" @restartSlider="restartSlider">
          <Tab
            v-for="planta in plantas"
            :key="planta.code"
            :title="planta.code"
            :map="true"
          >
            <!--
              El plano. Con plano limpio de planta se pinta una vez y el
              resalte va encima; sin el, se cambia de imagen al pasar de
              tarjeta, que es lo que hacia antes con los diecinueve PNG.
            -->
            <div class="map__plano top-to-bottom--effect">
              <img v-if="planoDe(planta)" :src="planoDe(planta)" class="map__img" />
              <span
                v-if="planta.plan && resalteDe(planta)"
                class="map__punto"
                :style="estiloDelPunto(resalteDe(planta))"
              ></span>
            </div>
            <div
              v-if="planoDe(planta)"
              :style="{ backgroundImage: `url(${planoDe(planta)})` }"
              class="map__img-background"
            ></div>
            <div
              v-if="selectedTitle === planta.code && planta.zonas.length < 3"
              class="map__pocas"
            >
              <div
                v-for="(zona, index) in planta.zonas"
                :key="zona.code"
                class="map__pocas--tarjeta"
                @click="changeMapImage(index); irAZona(zona)"
              >
                <Card
                  :class="{ 'selected-card': selectedIndex === index }"
                  :width="'300px'"
                  :height="'100%'"
                  :imageHeight="'145px'"
                  :imageDesktopHeight="'230px'"
                  :image="zona.image"
                  :title="zona.titulo"
                  :subtitle="zona.subtitulo"
                  :cursor="zona.url ? 'pointer' : 'default'"
                />
              </div>
            </div>
            <Slider
              v-else-if="selectedTitle === planta.code"
              @changeMapImage="changeMapImage"
              :autoplay="true"
              :autoplayTime="2000"
              :pagination="true"
              cardHeight="auto"
              :bound="false"
              :circular="true"
              :align="'center'"
              :map="true"
              heightViewport="100%"
              heightCamera="100%"
            >
              <template #content>
                <div
                  class="card-slide"
                  width="100%"
                  v-for="(zona, index) in planta.zonas"
                  :key="zona.code"
                  @click="irAZona(zona)"
                >
                  <Card
                    :class="{ 'selected-card': selectedIndex === index }"
                    :width="'500px'"
                    :height="'100%'"
                    :imageHeight="'145px'"
                    :imageDesktopHeight="'230px'"
                    :image="zona.image"
                    :title="zona.titulo"
                    :subtitle="zona.subtitulo"
                    :cursor="zona.url ? 'pointer' : 'default'"
                  />
                </div>
              </template>
            </Slider>
          </Tab>
        </Tabs>
      </div>
    </div>
    <div class="back-top">
      <button
        class="button-block button__light--block"
        @click="scrollToAnchor('#app')"
      >
        {{ $t('home.back') }}
      </button>
    </div>
  </div>

  <!-- Solo maqueta: acceso al panel de desarrollo. No se renderiza sin VUE_APP_DEV_TOOLS -->
  <button v-if="devTools" class="dev-fab" @click="$router.push({ name: 'DevTools' })">
    Panel dev
  </button>
</template>

<script setup>
  // Solo maqueta: ver DevToolsView.vue
  const devTools = process.env.VUE_APP_DEV_TOOLS === 'true'

  import router from '@/router'
  import { useStore } from 'vuex'
  import Slider from '@/components/movistar/common/Slider.vue'
  import CardIntro from '@/components/movistar/cards/CardIntro.vue'
  import Card from '@/components/movistar/cards/Card.vue'
  import CardSelectionSkeleton from '@/components/movistar/skeletons/CardSelectionSkeleton.vue'
  import CardSelection from '@/components/movistar/cards/CardSelection.vue'
  import IntroTitle from '@/components/movistar/common/IntroTitle.vue'
  import Tabs from '@/components/movistar/common/Tabs.vue'
  import Tab from '@/components/movistar/common/Tab.vue'
  import LanguageChange from '@/components/movistar/common/LanguageChange.vue'
  import { IconChevronDown } from '@tabler/icons-vue'
  import commonMethods from '@/commonMethods'
  import { ref, onMounted, onBeforeUnmount, computed, watch } from 'vue'
  import { useI18n } from 'vue-i18n'
  import axios from 'axios'

  const { scrollToAnchor, scrollToClassName, registerError, translate } =
    commonMethods()
  const store = useStore()
  const imageHost = ref(process.env.VUE_APP_IMAGE_HOST)

  const cardsSliderIntro = ref([])

  const { locale } = useI18n()
  const banners = computed(() => store.getters['getBannerSlides'])

  function navigateToPage(card) {
    if (card.url) {
      const cardUrl = new URL(card.url, window.location.origin)

      const isSameDomain = cardUrl.hostname === window.location.hostname
      const isSamePath = cardUrl.pathname === window.location.pathname

      if (isSameDomain && isSamePath) {
        const scrollToClass = cardUrl.searchParams.get('scrollToClass')
        if (scrollToClass) {
          scrollToClassName(scrollToClass)
        } else {
          router.push(cardUrl.pathname + cardUrl.search + cardUrl.hash)
        }
      } else if (isSameDomain) {
        const relativePath = cardUrl.pathname + cardUrl.search + cardUrl.hash
        router.push(relativePath)
      } else {
        window.open(card.url, '_blank')
      }
    } else if (card.path) {
      router.push({ name: card.path })
    }
  }
  const fetchSliderData = async (changelocale = false) => {
    try {
      if (changelocale) {
        await store.dispatch('bannerSlidesData')
      }

      cardsSliderIntro.value = []

      banners.value.forEach((banner) => {
        const slides = banner.app || []

        slides.forEach((slide) => {
          const localeCode = String(locale.value).trim().toLowerCase()

          const content =
            slide.locale.find(
              (localeData) =>
                localeData.code.trim().toLowerCase() === localeCode
            ) ||
            slide.locale.find(
              (localeData) => localeData.code.trim().toLowerCase() === 'es'
            )

          if (content) {
            cardsSliderIntro.value.push({
              title: content.title || '',
              subtitle: content.subtitle || '',
              image: content.image || slide.image,
              imageReduce: content.image || slide.imageReduce,
              justify: 'flex-end',
              align: 'initial',
              url: slide.url,
              button: content.buttonTitle || '',
              titleColor: slide.titleColor || '',
              subtitleColor: slide.subtitleColor || '',
              buttonColor: slide.buttonColor || '',
              buttonTextColor: slide.buttonTextColor || '',
              titleColorReduce: slide.titleColorReduce || '',
              subtitleColorReduce: slide.subtitleColorReduce || '',
              buttonColorReduce: slide.buttonColorReduce || '',
              buttonTextColorReduce: slide.buttonTextColorReduce || '',
              anchor: true
            })
          }
        })
      })
    } catch (error) {
      console.error('Error loading slider data:', error)
    }
  }

  // Lo mismo que decide `getImage`: la imagen de movil se ve en pantallas estrechas
  // y en las verticales. Los colores tienen que seguir a la imagen.
  const enMovil = () => width.value <= 576 || height.value > width.value

  // El color del tamano que toca: el de la imagen de movil o, si no lo hay, el de la
  // web. El API ya manda el de la web cuando no se ha elegido otro; el `||` es por
  // si el CMS que contesta es anterior a eso.
  const colorDe = (card, campo) =>
    (enMovil() ? card[campo + 'Reduce'] || card[campo] : card[campo]) || ''

  // El boton con los colores del gestor. Sin elegir ninguno, el de siempre.
  const estiloDelBoton = (card) => {
    const relleno = colorDe(card, 'buttonColor')
    const texto = colorDe(card, 'buttonTextColor')

    if (!relleno && !texto) return null

    return {
      ...(relleno ? { background: relleno, borderColor: relleno } : {}),
      ...(texto ? { color: texto } : {})
    }
  }

  const getImage = (card) => {
    if (width.value <= 576 || height.value > width.value) {
      return card.imageReduce
    } else {
      return card.image
    }
  }

  const CardsSelection = ref([
  //  {
  //    title: 'home.cards.card-0.title',
  //    subtitle: 'home.cards.card-0.subtitle',
  //    image: 'img/card_home_01.jpg',
  //    url: 'ExperienceTypes'
  //  }
  ])
  /*
   * Las plantas, tal como las va a pintar la plantilla.
   *
   * Del API llega cada texto en todos los idiomas -igual que en los banners- y
   * aqui se elige el que toca. Con caida al castellano: un idioma a medio
   * traducir tiene que ensenar algo, no un hueco.
   */
  const venueMap = computed(() => store.getters['getVenueMap'] || [])

  const enIdioma = (lista, campo) => {
    if (!lista || !lista.length) return ''

    const codigo = String(locale.value).trim().toLowerCase()
    const suyo =
      lista.find((t) => String(t.code).trim().toLowerCase() === codigo) ||
      lista.find((t) => String(t.code).trim().toLowerCase() === 'es') ||
      lista[0]

    return (suyo && suyo[campo]) || ''
  }

  const plantas = computed(() =>
    venueMap.value.map((planta) => ({
      code: planta.code,
      nombre: enIdioma(planta.locale, 'name') || planta.code,
      plan: planta.plan,
      zonas: (planta.zones || []).map((zona) => ({
        code: zona.code,
        titulo: enIdioma(zona.locale, 'title'),
        subtitulo: enIdioma(zona.locale, 'subtitle'),
        image: zona.image,
        planHighlight: zona.planHighlight,
        hotspot: zona.hotspot,
        url: zona.url,
        external: zona.external
      }))
    }))
  )

  // Los rotulos de las pestanas en movil. La clave es el codigo de la planta,
  // que es unico por sede; el nombre podria repetirse y dejaria dos pestanas
  // indistinguibles.
  const pestanas = computed(() =>
    plantas.value.map((planta) => ({ clave: planta.code, texto: planta.nombre }))
  )

  const irAZona = (zona) => {
    if (zona.url) navigateToPage(zona)
  }

  const selectedTab = ref(0)
  const selectedIndex = ref(0)
  const selectedDesktopIndex = ref(0)
  let selectedTitle = ref(null)
  const mapDekstop = ref(0)

  /*
   * Que plano se ensena.
   *
   * El limpio de la planta si lo hay; si no, el de la tarjeta que se esta
   * mirando, que es el de siempre con el resalte pintado dentro. Los dos
   * conviven a proposito: hoy no existe ningun plano limpio, y la transicion
   * va planta por planta segun se vayan subiendo.
   */
  const planoDe = (planta, indice = null) => {
    if (planta.plan) return planta.plan

    const i = indice === null ? selectedIndex.value : indice
    const zona = planta.zonas[i] || planta.zonas[0]

    return zona ? zona.planHighlight : null
  }

  const resalteDe = (planta, indice = null) => {
    const i = indice === null ? selectedIndex.value : indice
    const zona = planta.zonas[i] || planta.zonas[0]

    return zona ? zona.hotspot : null
  }

  /*
   * Todo en porcentaje, que es como viene. Sin ancho ni alto es un punto y se
   * le da un tamano fijo; con ellos, un rectangulo del tamano que diga el
   * gestor.
   */
  const estiloDelPunto = (punto) => {
    const tiene = punto.w > 0 && punto.h > 0

    return {
      left: punto.x + '%',
      top: punto.y + '%',
      width: tiene ? punto.w + '%' : '44px',
      height: tiene ? punto.h + '%' : '44px',
      borderRadius: tiene ? '12px' : '999px',
      // Con caja, x/y son la ESQUINA de arriba a la izquierda y va tal cual:
      // asi la guarda el gestor al arrastrar y asi la comprueba el servidor
      // -`x + w <= 100`-. Sin caja son el centro de la marca, que es donde se
      // pulso: sin esto sale veintidos pixeles abajo y a la derecha.
      //
      // Si un resalte sale corrido media caja, lo que esta mal es el dato, no
      // esto. Paso con las zonas sembradas: `destacar.py` devolvia el centro.
      transform: tiene ? 'none' : 'translate(-50%, -50%)'
    }
  }

  const goToPage = (url) => {
    router.push({ name: url })
  }
  const restartSlider = (event) => {
    selectedTitle.value = event.title
    selectedTab.value = event.index
    selectedIndex.value = 0
  }
  /*
   * Cada maqueta lleva su indice, y no uno compartido.
   *
   * Las dos estan montadas a la vez -el CSS esconde una, pero su carrusel sigue
   * corriendo con autoplay- asi que con un solo indice el carrusel escondido le
   * movia el resalte al que se esta mirando cada dos segundos.
   */
  const changeMapImage = (event) => {
    selectedIndex.value = event
  }

  const changeMapImageDesktop = (event) => {
    selectedDesktopIndex.value = event
  }

  const changeMapDekstop = (floor) => {
    mapDekstop.value = floor
    // Al cambiar de planta se empieza por la primera zona de la nueva: dejar el
    // indice de la anterior resaltaria una zona que no es la de la tarjeta.
    selectedDesktopIndex.value = 0
  }

  const experienceTypes = computed(() => store.getters['getExperienceTypes'])

  // ¿Tiene el tipo alguna experiencia vigente hoy? Mismo criterio que la Agenda.
  // Sin esto, un tipo caducado seguía apareciendo en Home solo por isLiveAll.
  const someActiveExperience = (experiences) => {
    if (!experiences || experiences.length === 0) return false
    const now = new Date()
    return experiences.some(
      (experience) => experience.endDate == null || now <= new Date(experience.endDate)
    )
  }

  const experienceTypesFilter = computed(() =>
    experienceTypes.value.filter(
      (experienceType) =>
        experienceType.isLiveAll === true &&
        someActiveExperience(experienceType.experiences)
    )
  )

  const goTo = async (experienceType) => {
    store.commit('setExperienceType', experienceType)

    if (experienceType.code === 'CINE') {
      router.push({ name: 'Cinema' })
    } else {
      let experiences = await store.dispatch(
        'getExperiencesByType',
        experienceType.experienceTypeId
      )

      router.push({
        name: 'ExperiencesByType',
        params: {
          experienceTypeCode: experienceType.code
        }
      })
    }
  }

  const openWindow = (url) => {
    window.open(url, '_blank')
  }

  // Slider Cards Dekstop
  const width = ref(window.innerWidth)
  const height = ref(window.innerHeight)
  const alignSliderDesktop = ref('prev')
  const updateDimensions = () => {
    width.value = window.innerWidth
    height.value = window.innerHeight
    width.value <= 768
      ? (alignSliderDesktop.value = 'center')
      : (alignSliderDesktop.value = 'prev')
  }

  onMounted(() => {
    updateDimensions()
    window.addEventListener('resize', updateDimensions)
    fetchSliderData(true)
    store.dispatch('venueMapData')
    const scrollTo = router.currentRoute.value.query.scrollTo
    if (scrollTo) {
      scrollToAnchor(scrollTo)
    }
    const scrollToClass = router.currentRoute.value.query.scrollToClass
    if (scrollToClass) {
      scrollToClassName(scrollToClass)
    }
  })
  onBeforeUnmount(() => {
    window.removeEventListener('resize', updateDimensions)
  })

  watch(
    () => locale.value,
    (newLang) => {
      fetchSliderData(false)
    }
  )
</script>

<style lang="scss">
  @import '@/scss/mixings';

  .intro-page {
    width: 100%;
    height: 700px;
    @media screen and (min-width: $sm-breakpoint) {
      height: 65vh;
      position: relative;
    }
    .intro-header {
      @include d-flex(column, center, center, 1px);
      padding: 30px 30px;
      position: absolute;
      width: 100%;
      height: auto;
      z-index: 100;
      &__options {
        @include d-flex(row, center, center);
        width: 100%;
        @media screen and (min-width: $sm-breakpoint) {
          @include d-flex(row, flex-start, center);
        }
        &--sede {
          @include d-flex(column, center, flex-start, 2px);
          width: 130px;
          color: #fff;
          line-height: 1.2;
          white-space: nowrap;
          @media screen and (min-width: $sm-breakpoint) {
            display: none;
          }
        }
        &--sede-ciudad {
          font-family: 'OnAir-text-bold';
          font-size: 16px;
        }
        &--sede-direccion {
          font-size: 12px;
        }
        &--language {
          width: 100%;
          @media screen and (min-width: $sm-breakpoint) {
            display: none;
          }
        }
      }
      &__logo {
        width: 100px;
        height: auto;
        @media screen and (min-width: $sm-breakpoint) {
          display: none;
        }
      }
    }
  }
  .cards-menu {
    @include d-flex(row, space-between, initial, 20px);
    flex-wrap: wrap;
    width: 100%;
    padding: 0px 20px;

    @media screen and (min-width: $sm-breakpoint) {
      display: grid;
      grid-template-columns: repeat(1, 1fr);
      gap: 20px;
      padding: 0px 50px 20px 50px;
    }
    @media screen and (min-width: $lg-breakpoint) {
      display: grid;
      grid-template-columns: repeat(3, 1fr);
      gap: 50px;
      padding: 0px 50px 20px 50px;
    }
  }
  .map__pocas {
    @include d-flex(row, center, stretch, 20px);
    flex-wrap: wrap;
    padding: 0px 15px 30px;
    // Las dos tarjetas a la misma altura, aunque el texto de una ocupe mas lineas.
    &--tarjeta {
      display: flex;
      cursor: pointer;
    }
  }
  .card-slide {
    @include d-flex(row, flex-start, flex-end);
    border-radius: 5px;
    box-sizing: border-box;
    margin-bottom: 10px;
    margin-right: 0px;
    padding: 0px 15px 30px 5px;
    width: 500px;
    @media screen and (max-width: $md-breakpoint) {
      padding: 0px 15px 30px 3px;
      width: 320px;
    }
  }
  .map {
    @include d-flex(column, flex-start, initial);
    width: 100%;
    @media screen and (min-width: $sm-breakpoint) {
      padding: 30px 50px 50px 50px;
      background: var(--theme-color);
    }
    &__plano {
      position: relative;
      display: block;
      width: 100%;
      @media screen and (min-width: $lg-breakpoint) {
        display: none;
      }

      /*
       * El plano, a su tamano natural dentro del ancho que haya.
       *
       * Manda sobre el alto fijo y el `object-fit` de `.map__img`, y no es
       * cosmetica: el resalte se coloca en PORCENTAJE del contenedor, asi que
       * si la imagen se recorta -`cover`- o se queda con bandas -`contain`-,
       * el porcentaje deja de caer donde dice. Con el alto automatico la caja
       * y el dibujo son lo mismo, sea cual sea la medida del plano que alguien
       * suba.
       */
      img {
        /*
         * `display: block` no es de adorno: en linea, la imagen arrastra el
         * hueco de la linea base y la caja del contenedor sale cuatro pixeles
         * mas alta que el dibujo. El resalte se coloca en porcentaje SOBRE EL
         * CONTENEDOR, asi que esos cuatro pixeles se reparten por todo el
         * plano y las zonas de abajo caen bajas. Medido: 237 px de caja para
         * 233 de dibujo.
         */
        display: block;
        height: auto;
        object-fit: fill;
      }
    }

    /*
     * El plano arriba y las tarjetas debajo, que es como se lee la seccion.
     *
     * El plano no se estira a todo el ancho: un dibujo de 1173 px a 1.900
     * queda borroso y ademas obliga a bajar hasta el final para ver las
     * tarjetas. Se le pone un techo y se centra.
     *
     * El techo nacio en 760 px, bajo a 260 -un tercio- y esta en 520 desde el
     * 2026-09-20: a 260 el plano se quedaba corto y los rotulos de calle no se
     * leian. Es el unico numero que hay que tocar para subirlo o bajarlo: todo
     * lo demas -el resalte incluido- va en porcentaje y se escala solo.
     *
     * Aqui el dibujo no llena la imagen: el PNG lleva casi un 40 % de margen
     * vacio alrededor del edificio, asi que del techo que se ponga, el plano
     * de verdad ocupa unos dos tercios. De los 520, unos 320.
     */
    &__desktop {
      &--cuerpo {
        @include d-flex(column, flex-start, initial);
        gap: 24px;
        width: 100%;
      }

      &--plano {
        position: relative;
        width: 100%;
        max-width: 520px;
        align-self: center;

        /*
         * Lo mismo que en `&__plano`: el alto automatico y sin `object-fit`.
         * La caja del elemento tiene que medir lo que mide el dibujo, porque
         * el resalte se coloca en porcentaje sobre ella; con bandas dentro, el
         * porcentaje cae sobre las bandas y no sobre el plano.
         */
        img {
          display: block;
          width: 100%;
          height: auto;
        }
      }
    }

    &__punto {
      position: absolute;
      /*
       * Sin `transform` aqui. Lo pone `estiloDelPunto`, que es quien sabe si
       * esto es una sala o un punto: la sala se coloca por su esquina de
       * arriba a la izquierda y el punto por su centro. Poner aqui el
       * `translate(-50%, -50%)` de los puntos desplaza tambien a las salas,
       * que ya vienen colocadas.
       *
       * El resalte torcido que se vio el 2026-09-20 no salia de esta regla:
       * salia de que las treinta y cuatro zonas se habian sembrado con el
       * centro en el campo de la esquina. Lo arregla la migracion
       * `2026_09_20_120000_el_resalte_de_la_zona_guarda_la_esquina`.
       */
      border: 3px solid var(--primary-50-color);
      background: rgba(1, 157, 244, 0.18);
      // No se pulsa: el plano no es un menu, y encima taparia la foto de la
      // tarjeta que hay debajo en movil.
      pointer-events: none;
      transition: all 0.3s ease;
    }

    &__img {
      width: 100%;
      height: 245px;
      object-fit: contain;
      @media screen and (min-width: $md-breakpoint) {
        height: 480px;
        object-fit: cover;
      }
      @media screen and (min-width: $lg-breakpoint) {
        display: none;
      }
    }
    &__img-background {
      background-position: center;
      background-size: cover;
      height: 420px;
      width: 100%;
      display: none;
      @media screen and (min-width: $lg-breakpoint) {
        height: 470px;
        display: block;
      }
    }
    &__mobile {
      @media screen and (min-width: $sm-breakpoint) {
        display: none;
      }
    }
    &__desktop {
      display: none;
      @media screen and (min-width: $sm-breakpoint) {
        @include d-flex(column, flex-start, initial);
        gap: 30px;
      }
      &--floors {
        @include d-flex(row, flex-start, initial);
        gap: 10px;
      }
    }
    &__button {
      @include d-flex(column, center, center);
      width: 100px;
      height: 35px;
      min-width: 80px;
      padding: 5px 12px;
      border-radius: 20px;
      border: 1.5px solid #0066ff;
      color: #0066ff;
      font-size: 14px;
      font-weight: 500;
      line-height: 20px;
      cursor: pointer;
      &--active {

        background: #0066ff;
        border-color: #0066ff;
        //background: rgb(1, 157, 244);
        //background: linear-gradient(
        //  45deg,
        //  rgba(1, 157, 244, 1) -5%,
        //  rgba(11, 39, 57, 1) 50%
        //);

        color: #fffaf5;
      }
      &--disabled {
        //border-color: #066fcb;
        border-color: rgb(2, 45, 103);
        opacity: 0.4;
      }
    }
  }
  .back-top {
    @include d-flex(column, center, center);
    width: 100%;
    padding: 0px 30px 30px 30px;
    @media screen and (min-width: $sm-breakpoint) {
      display: none;
    }
  }

  .dev-fab {
    position: fixed;
    right: 1rem;
    bottom: 1rem;
    z-index: 9999;
    padding: 0.6rem 1.1rem;
    background: #b35c00;
    color: #fff;
    border: 0;
    border-radius: 24px;
    font-size: 0.85rem;
    font-weight: 600;
    cursor: pointer;
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.25);
  }
</style>
